<template>
  <div class="container">
    <table v-if="savings_items.length > 0" class="table is-hoverable center">
      <thead>
        <td>Type</td>
        <td>Amount</td>
        <td></td>
      </thead>
      <tbody>
        <tr v-for="(item, index) in savings_items" :key="index">
          <td>{{ item.name }}</td>
          <td>{{ new Intl.NumberFormat().format(item.amount) }}</td>
          <td>
            <a class="delete" @click="this.$emit('del-sav', item.id)"></a>
          </td>
        </tr>
        <tr>
          <td>Total Savings:</td>
          <td>{{ new Intl.NumberFormat().format(total_savings) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "SavingsItems",
  props: {
    savings_items: Array,
    total_savings: Number,
  },
  data() {
    return {
      //total_savings: 0,
    };
  },
  methods: {
    delSave(id) {
      this.$emit("del-sav", id);
    },
  },
  computed: {},
};
</script>

<style>
</style>